import { render, staticRenderFns } from "./ta-team-detail.html?vue&type=template&id=224adf83&"
import script from "./ta-team-detail.ts?vue&type=script&lang=ts&"
export * from "./ta-team-detail.ts?vue&type=script&lang=ts&"
import style0 from "./ta-team-detail.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports